export default __webpack_public_path__ + "static/media/evennumbers_locked.e9a75953.svg";